import { render } from "./ModalOrder.vue?vue&type=template&id=a751eefc"
import script from "./ModalOrder.vue?vue&type=script&lang=js"
export * from "./ModalOrder.vue?vue&type=script&lang=js"

import "./ModalOrder.vue?vue&type=style&index=0&id=a751eefc&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__